export function TaskCreationScreen() {
	return (
		<div className="space-y-6">
			{/* Heading */}
			<div className="space-y-3 text-center">
				<h2 className="text-2xl font-semibold tracking-tight">Delegate in plain English</h2>
			</div>

			{/* Examples */}
			<div className="space-y-3">
				<h3 className="text-sm font-medium text-muted-foreground">Examples:</h3>
				<div className="space-y-2">
					<div className="rounded-lg border bg-card px-3 py-2.5">
						<p className="text-sm leading-relaxed line-clamp-2">
							"Go through last week's Google Search Console and improve our blog posts for promising
							search terms"
						</p>
					</div>

					<div className="rounded-lg border bg-card px-3 py-2.5">
						<p className="text-sm leading-relaxed line-clamp-2">
							"Find deals in Hubspot that went quiet and draft follow-up emails for each one"
						</p>
					</div>

					<div className="rounded-lg border bg-card px-3 py-2.5">
						<p className="text-sm leading-relaxed line-clamp-2">
							"Every Friday pull the key conversations from Slack and post a recap in Notion"
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}
